import {css} from 'lit';
export const styles = css`:host{align-items:center;display:flex;fill:currentcolor;height:2.8rem;justify-content:center;width:2.8rem}::slotted(svg){height:2.8rem;width:2.8rem}`;
export default styles;
